// if some dynamic components are used frequently, a better way is to register them globally
export default {
  DisplayRow: require('./nested-Customer'),
  SubTrades: require('./nested-Trades'),
  ClientTrades: require('./nested-Trades'),
  Reports: require('./nested-Reports'),
  PortfolioReport: require('@/components/Accounts/PortfolioSummaryReport.vue'),
  UploadDocs: require('@/components/Accounts/UploadDocs'),
  Color: require('./td-Color'),
  CreatetimeTd: require('./td-Createtime'),
  CreatetimeTh: require('./th-Createtime'),
  'two-line-title': require('./th-2line-header'),
  Email: require('./td-Email'),
  Input: require('./td-Input'),
  IP: require('./td-IP'),
  Number: require('./td-number'),
  'fourD-Arr-Number': require('./td-4d-arr-number'),
  'fourD-Arr-String': require('./td-4d-arr-string'),
  'threeD-Arr-Number': require('./td-3d-arr-number'),
  'threeD-Arr-String': require('./td-3d-arr-string'),
  'index-as-value': require('./td-index-as-value'),
  Timestamp: require('./td-timestamp'),
  Opt: require('./td-Opt'),
  fxOpt: require('./td-fxOpt'),
  marginOpt: require('./td-marginOpt'),
  controlReportOpt: require('./td-ControlReportOpt'),
  reportOpt: require('./td-reportOpt'),
  tradeOpt: require('./td-tradeOpt'),
  clientTradeOpt: require('./td-clientTradeOpt'),
  emailOpt: require('./td-emailOpt'),
  tradeApprove: require('./td-tradeApprove'),
  ClientTrade: require('./td-ClientTrade'),
  customerApprove: require('./td-customerApprove'),
  tradeSecurityOpt: require('./td-securityOpt'),
  tradeSecurityType: require('./td-SecurityType'),
  transOpt: require('./td-transOpt'),
  UserOpt: require('./td-UserOpt'),
  FilterTh: require('./th-Filter'),
  VueElementLoading: require('vue-element-loading')
  // [Vue warn]: Do not use built-in or reserved HTML elements as component id: Filter
  // Filter: require('./th-Filter')
}
